import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 0;

  @media (max-width: 767px) {
    padding: 20px 0;
  }
`;

export const Pic = styled.div`
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid var(--aluminium35);
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  flex-grow: 1;
  min-width: 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    flex-wrap: wrap;
  }
`;

export const Description = styled.div`
  width: 300px;
  cursor: pointer;
  padding: 0 28px;
  min-width: 0;

  @media (max-width: 1024px) {
    width: 135px;
    padding: 0 15px;
  }

  @media (max-width: 767px) {
    order: 1;
    width: 90%;
    margin-bottom: 9px;
    padding: 0;
  }

  @media (orientation: landscape) and (max-width: 1023px) {
    order: 1;
    width: 90%;
    margin-bottom: 9px;
    padding: 0;
  }
`;

export const Packaging = styled.div`
  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
  }
`;

export const Title = styled.div`
  letter-spacing: -0.01em;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.29em;
  color: var(--blue100);
  transition: var(--transition);

  &:hover {
    color: var(--blue120);
  }
`;

export const Text = styled.div`
  font-size: 15px;
  color: var(--carbone70);
  padding-top: 5px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    font-size: 13px;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const Producer = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.6em;

  .icon {
    margin-right: 8px;
  }

  @media (max-width: 767px) {
    order: 1;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;

    .icon {
      top: -2px;
    }
  }
`;

export const Details = styled.div`
  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &:after {
      content: '';
      height: 16px;
      width: 1px;
      background: var(--aluminium60);
      margin: 0 12px;
    }
  }
`;

export const NumPackages = styled.div`
  margin: 0 10px 10px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    order: 3;
    margin: 0 0 10px;
  }
`;

export const NumParts = styled.div`
  margin: 0 10px 10px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    order: 3;
    margin: 0 0 10px;
  }
`;

export const Label = styled.div`
  font-size: 15px;
  color: var(--carbone70);
  width: 140px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    width: auto;
  }
`;

export const Amount = styled.div`
  width: 100px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    order: 4;
    width: auto;
    flex-shrink: 0;
  }
`;

export const Total = styled.div`
  font-size: 16px;
  line-height: 1.25em;
  font-weight: 700;
  color: var(--carbone100);
  padding-top: 16px;
  white-space: nowrap;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    padding-top: 0;
  }
`;

export const Content = styled.div`
  font-size: 16px;
  line-height: 1.25em;
  color: var(--carbone70);
  padding-top: 4px;

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    font-size: 14px;
  }
`;

export const Edit = styled.div`
  color: var(--red75);
  cursor: pointer;
  padding: 5px;
  right: -5px;
  top: -5px;
  position: relative;
  transition: var(--transition);

  &:hover {
    color: var(--red100);
  }

  @media (max-width: 767px), (orientation: landscape) and (max-width: 1023px) {
    order: 2;
    top: -8px;
  }
`;

export const Counter = styled.div`
  padding-top: 7px;
`;